import ChartShell from '../ChartShell';
import { areaOptions, MONTHS } from '../chartDefaults';

const data = [1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2.0, 2.1, 2.2, 2.3, 2.35, 2.4];

const HospitalityRevenueChart = ({ metric }) => (
  <ChartShell
    title={metric.title}
    value={metric.value}
    trend={metric.trend}
    trendValue={metric.trendValue}
    icon={metric.icon}
    caption="Room revenue (USD millions)"
    options={areaOptions({ categories: MONTHS, yFormatter: (v) => `$${v}M` })}
    series={[{ name: 'Room revenue', data }]}
  />
);

export default HospitalityRevenueChart;
